import request from '@utils/fetch'
// 园所管理

// 查询园所列表
export function getOrgList(data) {
  return request({
    url: '/organization/getOrgList',
    method: 'post',
    data
  })
}

// 新增园所
export function addOrg(data) {
  return request({
    url: '/organization/addOrg',
    method: 'post',
    data
  })
}

// 编辑园所
export function updateOrg(data) {
  return request({
    url: '/organization/updateOrg',
    method: 'post',
    data
  })
}

// 删除园所
export function delOrg(data) {
  return request({
    url: '/organization/delOrg',
    method: 'delete',
    params: data
  })
}
